// DragDropList.tsx
import React from 'react';
import { ServiceSelection, SongData } from '../../../types/planningTypes';
import { SelectionItem } from '../SelectionItem/SelectionItem';
import styles from '../DragDropList/dnd.module.css';



interface DragDropListProps {
  selections: ServiceSelection[];
  onChange: (selections: ServiceSelection[]) => void;
  onDelete: (index: number) => void;

}


export const DragDropList: React.FC<DragDropListProps> = ({
  selections,
  onChange,
  onDelete,
}) => {
  const moveSelection = (dragIndex: number, hoverIndex: number) => {
    const draggedSelection = {...selections[dragIndex]};
    const updatedSelections = selections.map(s => ({...s}));
    updatedSelections.splice(dragIndex, 1);
    updatedSelections.splice(hoverIndex, 0, draggedSelection);
    onChange(updatedSelections);
  };
  // Rest of component stays the same

  const handleInputChange = (index: number, field: keyof ServiceSelection, value: string) => {
    const updatedSelections = selections.map((selection, i) => {
      if (i === index) {
        return { ...selection, [field]: value };
      }
      return selection;
    });
    onChange(updatedSelections);
  };

  const handleSongSelect = (index: number, songData: SongData) => {
    const updatedSelections = selections.map((selection, i) => {
      if (i === index) {
        return {
          ...selection,
          song_id: songData.song_id,
          version_id: songData.version_id,
          song_title: songData.song_title,
          composer_name: songData.composer_name,
          lyricist_name: songData.lyricist_name,
          version_title: songData.version_title,
        };
      }
      return selection;
    });

    onChange(updatedSelections);
  };

  return (
    <div className={styles.container}>
     {selections.map((selection, index) => (
  <SelectionItem
    key={selection.service_selection_id || `temp-${selection.song_id}-${index}`}
    selection={selection}
    index={index}
    total={selections.length}
    moveSelection={moveSelection}
    onDelete={() => onDelete(index)}
    onChange={(field, value) => handleInputChange(index, field, value)}
    handleInputChange={handleInputChange}
    handleSongSelect={handleSongSelect}
  />
))}
    </div>
  );
};

export default DragDropList;
